/**
 * @file Transaction filter reducer.
 */

import { UPDATE_FILTER, RESET_FILTER } from '../actions/transaction-filter';
import { ACCOUNTS_FILTER, ACCOUNTS_LIMIT } from '../constants/transactions';

export const initialState = {
  accountsFilter: ACCOUNTS_FILTER.WITH_TRANSACTION_ITEMS,
  limit: ACCOUNTS_LIMIT,
  offset: 0,
};

const transactionFilterReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_FILTER:
      return {
        ...state,
        ...action.filter,
      };

    case RESET_FILTER:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default transactionFilterReducer;
